/**
 * Utility for Google Analytics (gtag) and Google Tag Manager (dataLayer) event tracking.
 */

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    dataLayer?: any[];
  }
}

export const trackEvent = (action: string, category: string, label: string, value?: number) => {
  try {
    // 1. Google Analytics event
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', action, {
        event_category: category,
        event_label: label,
        value: value,
      });
    }

    // 2. Google Tag Manager dataLayer push
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'custom_event',
        event_action: action,
        event_category: category,
        event_label: label,
        event_value: value,
      });
    }
  } catch (error) {
    console.warn('Analytics tracking error:', error);
  }
};

export const trackPhoneClick = (label: string) => {
  trackEvent('click_phone', 'engagement', label);
};

export const trackWhatsAppClick = (label: string) => {
  trackEvent('click_whatsapp', 'engagement', label);
};

export const trackAppointmentSubmit = (label: string) => {
  trackEvent('submit_appointment', 'conversion', label);
};
